import axios from "axios";

export async function getAdmin(id) {
  try {
    const response = await axios.get("/admin", { params: { id } });
    return response.data;
  } catch (e) {
    return e;
  }
}

export async function updateAdmin(admin, id) {
  try {
    const response = await axios.put("/admin/" + id, admin, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response;
  } catch (e) {
    return e;
  }
}

export async function updatePassword({ oldPass, newPass, id, reset }) {
  try {
    const headers = {
      "Content-Type": "application/json"
    };

    const response = await axios.patch(
      "/admin/change-password",
      {
        id,
        newPass,
        oldPass,
        reset
      },
      { headers }
    );
    return response.data;
  } catch (error) {
    console.log("🚀 ~ updatePassword ~ error:", error);
    if (error.response?.status === 401) {
      throw new Error("Unauthorized: Please login again");
    }
    throw error;
  }
}

export async function getAdminId(email) {
  try {
    const response = await axios.get("/admin/get-id-by-email", { params: { email } });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function resetPassword({ newPass, id }) {
  const response = await axios.patch(
    "/admin/reset-password",
    {
      id,
      newPass
    },
    { "Content-Type": "application/json" }
  );
  return response;
}
